(() => {
  const videos = document.querySelectorAll('.ph-ugc-video-grid video[data-poster]');

  const loadPoster = (video) => {
    if (!video.dataset.poster) return;
    video.poster = video.dataset.poster;
    delete video.dataset.poster;
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach(loadPoster);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadPoster(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '400px 0px' }
  );

  videos.forEach((video) => observer.observe(video));
})();
